import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsTC: CultureInfo = {
  name: 'es-TC',
  displayName: 'español (Islas Turcas y Caicos)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-TC',
  parent: CultureInfoEs
};
